import React, { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { Modal, ModalBody } from "react-bootstrap";
import isNull from '../../../../../../../../../../../../utils/NullChecking'
import { ServerRequestProtected } from '../../../../../../../../../../../../utils/ServerDataRequest';
import NotificationHandler from '../../../../../../../../../../../../utils/NotificationHandler';
import { enumUtil } from '../../../../../../../../../../../../utils/Enum';
import FormValidator from '../../../../../../../../../../../../utils/FormValidator';
// import DatePicker from '../../../../../../../../../../General/DatePicker';
import ModalHeader from '../../../../../../../../../../../Setup/Shared/ModalHeader';
import Loader from '../../../../../../../../../../../shared/Loader/Loader';
import DeleteConfirmatiom from '../../../../../../../../../../../General/DeleteConfirmation';
// import SuperSearchList from '../../../../../../../../../../shared/SuperSearch/SuperSearchList';

const AddNewMajorEvents = (props) => {
    const { isOpenMajorEvents, onClose, majorEventData, setIsRecordSaved, onDeleteMajorEvents, patientID, IsEditAllowed } = { ...props }
    const API_URL = enumUtil.controller.General
    let MajorEvents_Modal = {
        Notes: majorEventData.Notes || "",
    }
    
    let MajorEvents_Modal_Default = {
        Notes: "",
    }
    let valModal = {}
    let ValidationModal = {
        NotesVal: "",
    }
    const [isOpenDeleteAlert, setisOpenDeleteAlert] = useState(false);
    const [majorEventID, setMajorEventID] = useState();
    const [majorEventsValidationModal, setMajorEventsValidationModal] = useState(ValidationModal)
    const [majorEventsSaveUpdateModal, setMajorEventsSaveUpdateModal] = useState({})
    const [mainMajorEventsModal, setMainMajorEventsModal] = useState(MajorEvents_Modal);
    const [isLoading, setIsLoading] = useState(false)
    const [onMajorEventsSaved, setOnMajorEventsSaved] = useState(false)
    const [del, setDel] = useState(false)
    const [searchDropdown, setSearchDropdown] = useState(false);
    const [is, setIs] = useState(false);

    useEffect(() => {
        if (majorEventData.PatientHistoryID != null) {
            setDel(true)
            setMajorEventID(majorEventData.PatientHistoryID)
        } else {
            if (!onMajorEventsSaved) {
                setMajorEventID(0);
                setDel(false)
            } else {
                setDel(true)
            }
        }
        if (!isNull(majorEventID)) {
        }
    }, [majorEventID])

    const MajorEventsValidation = async () => {
        let ValidationModal = {
            NotesVal: FormValidator(
                mainMajorEventsModal.Notes,
                enumUtil.enumValidationType.Required,
                'Notes',
            ),
        }
        await setMajorEventsValidationModal(ValidationModal)
        valModal = ValidationModal
    }
    const addNewMajorEvent = () => {
        props.setMajorEventData({ PatientHistoryID: null })
        setMajorEventID(null)
        handleClear();
    }
    const handleSaveMajorEvents = async (type) => {
        if(!IsEditAllowed) return;
        await MajorEventsValidation()
        let validation = FormValidator([valModal], enumUtil.enumValidationType.NullCheck)
        if (validation) {
            NotificationHandler('Fill Required Fields', enumUtil.enumtoaster.error)
            return
        } else {
            setMajorEventsSaveUpdateModal(majorEventsSaveUpdateModal)
            let data = {
                PatientID: patientID,
                HistoryType: "Past Medical History",
                HistorySubType: "Major Events",
                ...majorEventsSaveUpdateModal
            };

            let saveModal = {
                TableName: enumUtil.enumAPITableName.PatientHistory,
                ID: majorEventID,
                Data: { ...data },
            }
            setIsLoading(true)
            ServerRequestProtected(API_URL + "/SaveSingleRecord", 'post', saveModal)
                .then((response) => {
                    if (!isNull(response.id)) {
                        setIsLoading(false)
                        NotificationHandler(`Record Saved Successfully`, enumUtil.enumtoaster.success)
                        setIsRecordSaved(true)
                        setMajorEventID(response.id)
                        setOnMajorEventsSaved(true);
                        if (type === "Add Another") {
                            addNewMajorEvent();
                        } else {
                            onClose();
                        }
                    }
                }).catch((error) => {
                    setIsLoading(false)
                    console.log('error', error);
                    NotificationHandler(error.response.data, enumUtil.enumtoaster.error)
                })
        }
    }

    const handleClear = () => {
        setMainMajorEventsModal(MajorEvents_Modal_Default);
        setMajorEventsSaveUpdateModal({});
    }
    const handleChange = (e) => {
        let { name, value } = e.target
        let modal = { ...mainMajorEventsModal };
        let saveModal = { ...majorEventsSaveUpdateModal }
        modal[name] = value
        setMainMajorEventsModal(modal)
        for (var property in MajorEvents_Modal) {
            if (name === property) {
                saveModal[name] = value
            }
        }
        setMajorEventsSaveUpdateModal(saveModal)
    }

    const MajorEventsName = () => {
        return (
            <p className="heading">Past Medical History</p>
        )
    }

    const handleDeleteModal = () => {
        setisOpenDeleteAlert(true)
    }
    const onCloseDelete = () => {
        setisOpenDeleteAlert(false);
    }
    const onDelete = () => {
        props?.setIsRecordSaved(true);
        setisOpenDeleteAlert(false);
        onClose();
    }

    let DeleteConfirmation = "";
    if (isOpenDeleteAlert) {
        DeleteConfirmation = (
            <DeleteConfirmatiom
                isOpenAlert={isOpenDeleteAlert}
                hideReason={true}
                API_URL={API_URL}
                TableName={enumUtil.enumAPITableName.PatientHistory}
                ID={String(majorEventID)}
                onCloseDelete={onCloseDelete}
                onClose={onDelete}
            />
        );
    }
    let DeletePopup = "";
    if (del) {
        DeletePopup = (
            <button
                className={
                    props?.IsDeleteAllowed
                      ? 
                    "btn-icon-transparent"
                      : 
                      "btn-icon-transparent delete-btn-disabled"
                } onClick={handleDeleteModal}>
                <span className="icon"><i className="icon-delete"></i></span>
                <span className="title">Delete</span>
            </button>
        );
    }
    const textareaRef = useRef(null);

    const adjustTextareaHeight = () => {
        const textarea = textareaRef.current;
        if (textarea) {
            textarea.style.setProperty('height', 'auto', 'important');
            textarea.style.setProperty('height', `${textarea.scrollHeight}px`, 'important');
        }
    };
    useEffect(() => {
        adjustTextareaHeight();
    }, [mainMajorEventsModal.Notes]);
    return (
        <Modal show={isOpenMajorEvents} onHide={isOpenMajorEvents} backdrop="static" keyboard={false} centered dialogClassName="hk-modal-v1 ar_ehr_problems ar_new-popup-design">
            <Modal.Body>
                {DeleteConfirmation}
                {isLoading ? <Loader /> : null}
                <ModalHeader HideAuditIcon={"PatEncounter"} HeaderName={MajorEventsName} isOpenDeleteAlert={isOpenDeleteAlert} onCloseDelete={onCloseDelete} DeletePopup={DeletePopup} isClosed={onClose} />
                <div className="">
                    <div className=''>
                        <div className={`input my-2 ${majorEventsValidationModal.NotesVal ? 'error' : ''}`}>
                            <label className="pb-3px">Major Event</label>
                            <textarea
                                className="form-control overflow-hidden"
                                ref={textareaRef}
                                onInput={adjustTextareaHeight}
                                id='Notes'
                                name='Notes'
                                rows="3"
                                onChange={handleChange}
                                value={mainMajorEventsModal.Notes}
                            ></textarea>
                            {majorEventsValidationModal.NotesVal}
                        </div>
                    </div>
                </div>
            </Modal.Body>

            <div className='d-flex align-items-center pb-15 px-10 pt-2 br-top-1 za_br_light  ar_footer justify-content-between'>
                <button className='btn btn-outline  px-10 h-100 dark-clr' onClick={onClose}>Cancel</button>
                <div className="d-flex align-items-center gap-2">
                <button className={`btn btn-outline  px-10 h-100 validate-color ${IsEditAllowed ? '' : 'disable'}`} onClick={() => handleSaveMajorEvents("Add Another")}>Save & Add Another</button>
                <button className={`btn btn-validate px-10 h-100 ${IsEditAllowed ? '' : 'disable'}`}  onClick={handleSaveMajorEvents}>Save</button>
                </div>
            </div>
        </Modal>
    )
}

export default AddNewMajorEvents